import React from 'react';
import ReactDOM from 'react-dom';
var colorSchemes = {

    table:['#FFFFFF', '#EEEEEE', '#DDDDDD', '#CCCCCC', '#BBBBBB']
    //tables:[/*'#55BB55', '#77BB77', */'#99BB99', '#BBBBBB', '#DDBBDD', '#FFBBFF']

   // btn:['#FFBBBB', '#DDBBBB', '#BBBBBB', '#99BBBB', '#77BBBB', '#55BBBB']
}
var inlineStyle =
{
   verticalAlign:'top',
   display:'inline',
}

var blockStyle =
{
   verticalAlign:'top',
   display:'block',
}

var cellStyleLight =
{
   verticalAlign:'top',
   background: '#EEEEEE',
}

var cellStyleDark =
{
   verticalAlign:'top',
   background: '#CCCCCC',  
}



function ValOrRecursiveElem(props)
{
   var isObj = typeof props.val === 'object';
   
   var cellStyle =
   {
      verticalAlign:'top',
      background: colorSchemes['table'][1 + props.depth + (isObj ? 1 : 0)],
      //background: colorSchemes['table'][props.even ? 0 : 1],
      //background: colorSchemes['table'][isObj && !props.even ? 0 : 1],
   }
   
   //console.log("IsObj: " + isObj + " Recursive elemKey and val:", props.elemKey, props.val);

   return <tr style={cellStyle}><td>{props.elemKey}:</td><td>{(isObj ? <RecursiveField2 elem={props.val} depth={props.depth + 1} even={!props.even}/> : props.val)}</td></tr>;
}

class RecursiveField2 extends React.Component {
   constructor(props)
   {
      super(props);
      this.elem = props.elem;

      this.state = new Object();
      this.depth = this.props.depth == null ? 0 : this.props.depth;
      this.even = this.props.even === 'undefined' || this.props.even;
      
   }

   componentDidMount()
   {
     
   }


   render()
   {
      var elemKeys = [];

      //console.log("JEK");
      
      for(var key in this.props.elem)
      {
         elemKeys.push(key);
         //var val = this.props.elem[key];
         //console.log("Key: " + key + " val: " + val);
      }

      var keyCount = elemKeys.length;

      return (
         <table>
            <tbody>
         {elemKeys.map((k, i) =>
               <ValOrRecursiveElem key={i} elemKey={k} val={this.props.elem[k]} depth={this.depth} even={this.even}/>
            )}
            </tbody>
         </table>

     );
   }
}
export default RecursiveField2;


// WEBPACK FOOTER //
// ./js/RecursiveField2.jsx